import { render, staticRenderFns } from "./evaluationlabel.vue?vue&type=template&id=76b5b59d&scoped=true&"
import script from "./evaluationlabel.vue?vue&type=script&lang=js&"
export * from "./evaluationlabel.vue?vue&type=script&lang=js&"
import style0 from "./evaluationlabel.vue?vue&type=style&index=0&id=76b5b59d&scoped=true&lang=css&"
import style1 from "./evaluationlabel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b5b59d",
  null
  
)

export default component.exports